import braintree from "braintree-web-drop-in";
import Cookies from "js-cookie";
import { viewCartDataLayer, removeFromCartDataLayer } from "../autoload/gtm";
let cart = JSON.parse(localStorage.getItem("cart")) || [];
if (cart.length == 0 && themeVars["pagename"] == "checkout") {
  $(".entry-content").hide();
  $(".checkout-cards").css("float", "none");
}
let cartIcon = $(".header-icons__item_cart").children("div");

if (themeVars["template"] == "checkout.php") {
  loadCart();
}
let errors;

function loadCart() {
  let cart = JSON.parse(localStorage.getItem("cart")) || [];
  let processingOverlay = $(".processing-overlay");
  let checkoutPreloader = $(".checkout-cards__preloader");

  let cartEmpty = $(".checkout-empty");
  let fullCart = $(".checkout-fullcart");
  let checkoutHeader = $(".checkout-header");
  let promoCode = $(".promo-code");

  processingOverlay.addClass("show");
  if (cart.length > 0) {
    checkoutPreloader.addClass("show");

    $.ajax({
      url: themeVars.ajax_url,
      type: "POST",
      data: { action: "addToCart", data: cart, promoCode: promoCode.val() },
      success: function(response) {
        $(".tour-card__checkout-wrapper").html(response);

        let dataLayerItems = [];

        $(".tour-card__checkout-wrapper .tour-card__checkout").each(function() {
          let dataLayerItem = {
            item_brand: $(this).attr("data-brand"),
            item_id: $(this).attr("data-id"),
            item_name: $(this).attr("data-name"),
            item_variant: $(this).attr("data-variant"),
            price: $(this).attr("data-price"),
          };
          dataLayerItems.push(dataLayerItem);
        });

        fullCart.addClass("show");
        checkoutHeader.show();
        checkoutPreloader.removeClass("show");

        if ($(".tour-card__checkout-wrapper").children().length == 1) {
          emptyCart();
        }

        let city = $(".total__price").attr("data-maincity");
        localStorage.city = city;
        let totalPrice = $(".total__price").data("total-price");
        if (totalPrice >= 4000) {
          $(".form-group_address").css("display", "flex");
          $(".first-step__inputs_private input").attr("aria-required", "true");

          $('input[name="private-or-business"]').change(function() {
            $(".checkout-error-message").removeClass("show");
            $(".checkout-error-message__wrong-format").removeClass("show");
            $(".form-group input").removeClass("error");
            errors = 0;
            if (
              $('input[name="private-or-business"]:checked').val() == "business"
            ) {
              $(".first-step__inputs_business").toggleClass("show");
              $(".first-step__inputs_business .form-group").css(
                "display",
                "flex"
              );
              $(".first-step__inputs_private").toggleClass("show");
              $(".first-step__inputs_business input").attr(
                "aria-required",
                "true"
              );
              $(".first-step__inputs_private input").attr(
                "aria-required",
                "false"
              );
            } else {
              $(".first-step__inputs_business").toggleClass("show");
              $(".first-step__inputs_private").toggleClass("show");
              $(".first-step__inputs_business input").attr(
                "aria-required",
                "false"
              );
              $(".first-step__inputs_private input").attr(
                "aria-required",
                "true"
              );
            }
          });
        } else {
          $('input[name="private-or-business"]').change(function() {
            errors = 0;
            $(".checkout-error-message").removeClass("show");
            $(".checkout-error-message__wrong-format").removeClass("show");
            $(".form-group input").removeClass("error");

            if (
              $('input[name="private-or-business"]:checked').val() == "business"
            ) {
              $(".first-step__inputs_business").toggleClass("show");
              $(".first-step__inputs_private").toggleClass("show");

              $(".first-step__inputs_business input").attr(
                "aria-required",
                "true"
              );
              $(
                ".form-group_vat input, .form-group_company-reference input, .form-group_company-address input, .form-group_company-name input, .form-group_billing-email input"
              ).attr("aria-required", "false");

              $(".first-step__inputs_private input").attr(
                "aria-required",
                "false"
              );
            } else {
              $(".first-step__inputs_private").toggleClass("show");
              $(".first-step__inputs_business").toggleClass("show");
              $(".first-step__inputs_private input").attr(
                "aria-required",
                "true"
              );
              $(".form-group_address input").attr("aria-required", "false");
              $(".first-step__inputs_business input").attr(
                "aria-required",
                "false"
              );
            }
          });
        }
        viewCartDataLayer(parseInt($(".total__price").text()), dataLayerItems);
        setupBraintree();
      },
    });
  } else {
    processingOverlay.removeClass("show");
    checkoutHeader.hide();
    cartEmpty.addClass("show");
  }
}

function setupBraintree() {
  let currency = Cookies.get("currency");
  localStorage.nonce = "";
  localStorage.currency = currency;

  $.ajax({
    url: themeVars.ajax_url,
    type: "POST",
    data: {
      action: "getBraintreeToken",
      city: localStorage.city,
      currency: localStorage.currency,
    },
    success: function(token) {
      activateBraintreePaymentForm(token.data);
      $(".processing-overlay").removeClass("show");
    },
  });
}

function activateBraintreePaymentForm(token) {
  braintree.create(
    {
      authorization: token,
      container: "#dropin-container",
      threeDSecure: true,
      locale: themeVars.lang,
      card: {
        cardholderName: {
          required: true,
        },
      },
    },
    (createErr, instance) => paymentCallback(createErr, instance)
  );
}

function paymentCallback(createErr, instance) {
  let button = $(".checkout-pay");

  if (createErr) {
    console.error(createErr);
    return;
  }

  button.on("click", function(e) {
    e.preventDefault();
    button.siblings(".checkout-error-message").removeClass("show");

    let firstName = $(".first-name").val();
    let lastName = $(".last-name").val();
    let email = $(".email").val();
    //let mobile = $(".mobile").val();
    let amount = parseInt($(".total__price").html());

    var threeDSecureParameters = {
      amount: amount,
      email: email,
      billingAddress: {
        givenName: firstName,
        surname: lastName,
      },
    };

    instance.requestPaymentMethod(
      {
        threeDSecure: threeDSecureParameters,
      },
      function(requestPaymentMethodErr, payload) {
        if (requestPaymentMethodErr) {
          console.error(requestPaymentMethodErr);
          return;
        }
        button.hide();
        localStorage.nonce = payload.nonce;

        $(".third-step__clients-payment-method").text(payload.details.cardType);
        $(".third-step__clients-card-expiration").text(
          payload.details.expirationMonth + "/" + payload.details.expirationYear
        );
        $(".third-step__clients-card-number").text(
          payload.details.bin + "xxxxxx" + payload.details.lastFour
        );

        $(".second-step").addClass("hide-step");
        $(".third-step").removeClass("hide-step");
        $(".checkout-steps__payment").addClass(
          "checkout-steps__payment_checked"
        );
        $(".checkout-steps__confirmation").addClass(
          "checkout-steps__confirmation_active"
        );
        $(".third-step__clients-name").text(
          $(".first-name").val() + " " + $(".last-name").val()
        );
        $(".third-step__clients-email").text($(".email").val());
        $(".third-step__clients-mobile").text($(".mobile").val());
        $(".third-step__clients-name-on-card").text($(".name-on-card").val());
        $("html, body").animate(
          { scrollTop: $(".checkout-steps").offset().top - 100 },
          100
        );
      }
    );
  });
}

$(document).on("click", ".braintree-large-button", function() {
  $(".checkout-pay").show();
});
// eslint-disable-next-line no-unused-vars
function isEmail(email) {
  var emailCheck = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return emailCheck.test(email);
}

$(".mobile, .mobile-business").change(function phoneFormat(e) {
  const t = e.target;
  let i = t.value
    .replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
  const o = i[2]
    ? `(${i[1]}) - ${i[2]}` +
      (i[3] ? ` - ${i[3]}` : "") +
      (i[4] ? ` - ${i[4]}` : "")
    : i[1];
  t.value = o;
});

$(".card-number").change(function cardNumber(e) {
  const t = e.target;
  let i = t.value
    .replace(/\D/g, "")
    .match(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/);
  const o = `${i[1]}${i[2]}${i[3]}${i[4]}`;
  t.value = o;
});

$(".card-expiration").change(function cardNumber(e) {
  const t = e.target;
  let i = t.value.replace(/\D/g, "").match(/(\d{0,2})(\d{0,2})/);
  const o = `${i[1]}/${i[2]}`;
  t.value = o;
});

$(".card-cvv").change(function cardCVV(e) {
  const t = e.target;
  let i = t.value.replace(/\D/g, "");
  t.value = i;
});

$(".checkout-next").click(function(e) {
  e.preventDefault();
  errors = 0;
  let firstName = $(".first-name");
  let lastName = $(".last-name");
  let email = $(".email");
  let mobile = $(".mobile");
  let address = $(".address");
  let firstNameBusiness = $(".first-name-business");
  let lastNameBusiness = $(".last-name-business");
  let emailBusiness = $(".email-business");
  let mobileBusiness = $(".mobile-business");
  let companyName = $(".company-name");
  let companyAddress = $(".company-address");
  let vat = $(".vat");

  if (vat.val() == "" && vat.attr("aria-required") === "true") {
    errors++;
    vat.addClass("error");
    vat.siblings(".checkout-error-message").addClass("show");
  } else {
    vat.removeClass("error");
    vat.siblings(".checkout-error-message").removeClass("show");
  }
  if (companyName.val() == "" && companyName.attr("aria-required") === "true") {
    errors++;
    companyName.addClass("error");
    companyName.siblings(".checkout-error-message").addClass("show");
  } else {
    companyName.removeClass("error");
    companyName.siblings(".checkout-error-message").removeClass("show");
  }
  if (firstName.val() == "" && firstName.attr("aria-required") === "true") {
    errors++;
    firstName.addClass("error");
    firstName.siblings(".checkout-error-message").addClass("show");
  } else {
    firstName.removeClass("error");
    firstName.siblings(".checkout-error-message").removeClass("show");
  }
  if (
    firstNameBusiness.val() == "" &&
    firstNameBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    firstNameBusiness.addClass("error");
    firstNameBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    firstNameBusiness.removeClass("error");
    firstNameBusiness.siblings(".checkout-error-message").removeClass("show");
  }

  if (address.val() == "" && address.attr("aria-required") === "true") {
    errors++;
    address.addClass("error");
    address.siblings(".checkout-error-message").addClass("show");
  } else {
    address.removeClass("error");
    address.siblings(".checkout-error-message").removeClass("show");
  }
  if (
    companyAddress.val() == "" &&
    companyAddress.attr("aria-required") === "true"
  ) {
    errors++;
    companyAddress.addClass("error");
    companyAddress.siblings(".checkout-error-message").addClass("show");
  } else {
    companyAddress.removeClass("error");
    companyAddress.siblings(".checkout-error-message").removeClass("show");
  }
  if (lastName.val() == "" && lastName.attr("aria-required") === "true") {
    errors++;
    lastName.addClass("error");
    lastName.siblings(".checkout-error-message").addClass("show");
  } else {
    lastName.removeClass("error");
    lastName.siblings(".checkout-error-message").removeClass("show");
  }
  if (
    lastNameBusiness.val() == "" &&
    lastNameBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    lastNameBusiness.addClass("error");
    lastNameBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    lastNameBusiness.removeClass("error");
    lastNameBusiness.siblings(".checkout-error-message").removeClass("show");
  }
  if (isEmail(email.val()) == false && email.attr("aria-required") === "true") {
    errors++;
    email.addClass("error");
    email.siblings(".checkout-error-message__wrong-format").addClass("show");
  } else {
    email.removeClass("error");
    email.siblings(".checkout-error-message__wrong-format").removeClass("show");
  }

  if (email.val() == "" && email.attr("aria-required") === "true") {
    errors++;
    email.addClass("error");
    email.siblings(".checkout-error-message").addClass("show");
  } else {
    email.removeClass("error");
    email.siblings(".checkout-error-message").removeClass("show");
  }

  if (
    isEmail(emailBusiness.val()) == false &&
    emailBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    emailBusiness.addClass("error");
    emailBusiness
      .siblings(".checkout-error-message__wrong-format")
      .addClass("show");
  } else {
    emailBusiness.removeClass("error");
    emailBusiness
      .siblings(".checkout-error-message__wrong-format")
      .removeClass("show");
  }

  if (
    emailBusiness.val() == "" &&
    emailBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    emailBusiness.addClass("error");
    emailBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    emailBusiness.removeClass("error");
    emailBusiness.siblings(".checkout-error-message").removeClass("show");
  }

  if (
    mobileBusiness.val() == "" &&
    mobileBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    mobileBusiness.addClass("error");
    mobileBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    mobileBusiness.removeClass("error");
    mobileBusiness.siblings(".checkout-error-message").removeClass("show");
  }

  if (mobile.val() == "" && mobile.attr("aria-required") === "true") {
    errors++;
    mobile.addClass("error");
    mobile.siblings(".checkout-error-message").addClass("show");
  } else {
    mobile.removeClass("error");
    mobile.siblings(".checkout-error-message").removeClass("show");
  }
  if (errors == 0) {
    $(".checkout-steps__payment").addClass("checkout-steps__payment_active");
    $(".checkout-steps__details").addClass("checkout-steps__payment_checked");
    $(".checkout-steps__details").removeClass("checkout-steps__details_active");
    $(".first-step").addClass("hide-step");
    $(".second-step").removeClass("hide-step");
  }
});

$('input[name="giftcard"]').change(function() {
  if ($(this).is(":checked")) {
    $(".first-step__gift-card").show();
  } else {
    $(".first-step__gift-card").hide();
  }
});

$('input[name="promocode"]').change(function() {
  if ($(this).is(":checked")) {
    $(".first-step__promo-code").show();
  } else {
    $(".first-step__promo-code").hide();
  }
});

let nonceChecker;
function hasNonce() {
  console.log("checking");
  let nonce = localStorage.nonce;
  if (typeof nonce !== undefined && nonce !== "") {
    clearInterval(nonceChecker);
    $(".checkout-submit").trigger("click");
    console.log("clear interval");
  }
}

$(".checkout-submit").click(function(e) {
  e.preventDefault();
  let messagesBox = $(".checkout-result-messages ul");
  messagesBox.html("");
  $(".error").removeClass("error");

  // payment process
  //collect data for payments
  let nonce = localStorage.nonce;
  let currency = localStorage.currency;
  let city = localStorage.city;
  let amount = parseInt($(".total__price").html());

  let integrityPolicy = $(".integrity-policy");
  let termsConditions = $(".terms-conditions");

  errors = 0;
  let firstName = $(".first-name");
  let lastName = $(".last-name");
  let email = $(".email");
  let mobile = $(".mobile");
  let address = $(".address");
  let firstNameBusiness = $(".first-name-business");
  let lastNameBusiness = $(".last-name-business");
  let emailBusiness = $(".email-business");
  let billingEmailBusiness = $(".billing-email");
  let mobileBusiness = $(".mobile-business");
  let companyName = $(".company-name");
  let companyAddress = $(".company-address");
  let companyReference = $(".company-reference");
  let vat = $(".vat");
  let gitCardCode = $(".gift-card");

  if (vat.val() == "" && vat.attr("aria-required") === "true") {
    errors++;
    vat.addClass("error");
    vat.siblings(".checkout-error-message").addClass("show");
  } else {
    vat.removeClass("error");
    vat.siblings(".checkout-error-message").removeClass("show");
  }
  if (companyName.val() == "" && companyName.attr("aria-required") === "true") {
    errors++;
    companyName.addClass("error");
    companyName.siblings(".checkout-error-message").addClass("show");
  } else {
    companyName.removeClass("error");
    companyName.siblings(".checkout-error-message").removeClass("show");
  }
  if (firstName.val() == "" && firstName.attr("aria-required") === "true") {
    errors++;
    firstName.addClass("error");
    firstName.siblings(".checkout-error-message").addClass("show");
  } else {
    firstName.removeClass("error");
    firstName.siblings(".checkout-error-message").removeClass("show");
  }
  if (
    firstNameBusiness.val() == "" &&
    firstNameBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    firstNameBusiness.addClass("error");
    firstNameBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    firstNameBusiness.removeClass("error");
    firstNameBusiness.siblings(".checkout-error-message").removeClass("show");
  }

  if (address.val() == "" && address.attr("aria-required") === "true") {
    errors++;
    address.addClass("error");
    address.siblings(".checkout-error-message").addClass("show");
  } else {
    address.removeClass("error");
    address.siblings(".checkout-error-message").removeClass("show");
  }
  if (
    companyAddress.val() == "" &&
    companyAddress.attr("aria-required") === "true"
  ) {
    errors++;
    companyAddress.addClass("error");
    companyAddress.siblings(".checkout-error-message").addClass("show");
  } else {
    companyAddress.removeClass("error");
    companyAddress.siblings(".checkout-error-message").removeClass("show");
  }
  if (lastName.val() == "" && lastName.attr("aria-required") === "true") {
    errors++;
    lastName.addClass("error");
    lastName.siblings(".checkout-error-message").addClass("show");
  } else {
    lastName.removeClass("error");
    lastName.siblings(".checkout-error-message").removeClass("show");
  }
  if (
    lastNameBusiness.val() == "" &&
    lastNameBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    lastNameBusiness.addClass("error");
    lastNameBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    lastNameBusiness.removeClass("error");
    lastNameBusiness.siblings(".checkout-error-message").removeClass("show");
  }
  if (isEmail(email.val()) == false && email.attr("aria-required") === "true") {
    errors++;
    email.addClass("error");
    email.siblings(".checkout-error-message__wrong-format").addClass("show");
  } else {
    email.removeClass("error");
    email.siblings(".checkout-error-message__wrong-format").removeClass("show");
  }

  if (email.val() == "" && email.attr("aria-required") === "true") {
    errors++;
    email.addClass("error");
    email.siblings(".checkout-error-message").addClass("show");
  } else {
    email.removeClass("error");
    email.siblings(".checkout-error-message").removeClass("show");
  }

  if (
    isEmail(emailBusiness.val()) == false &&
    emailBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    emailBusiness.addClass("error");
    emailBusiness
      .siblings(".checkout-error-message__wrong-format")
      .addClass("show");
  } else {
    emailBusiness.removeClass("error");
    emailBusiness
      .siblings(".checkout-error-message__wrong-format")
      .removeClass("show");
  }

  if (
    emailBusiness.val() == "" &&
    emailBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    emailBusiness.addClass("error");
    emailBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    emailBusiness.removeClass("error");
    emailBusiness.siblings(".checkout-error-message").removeClass("show");
  }

  if (
    mobileBusiness.val() == "" &&
    mobileBusiness.attr("aria-required") === "true"
  ) {
    errors++;
    mobileBusiness.addClass("error");
    mobileBusiness.siblings(".checkout-error-message").addClass("show");
  } else {
    mobileBusiness.removeClass("error");
    mobileBusiness.siblings(".checkout-error-message").removeClass("show");
  }

  if (mobile.val() == "" && mobile.attr("aria-required") === "true") {
    errors++;
    mobile.addClass("error");
    mobile.siblings(".checkout-error-message").addClass("show");
  } else {
    mobile.removeClass("error");
    mobile.siblings(".checkout-error-message").removeClass("show");
  }

  if (!integrityPolicy.is(":checked")) {
    errors++;
    integrityPolicy.siblings(".checkout-error-message").addClass("show");
  } else {
    integrityPolicy.siblings(".checkout-error-message").removeClass("show");
  }

  if (!termsConditions.is(":checked")) {
    errors++;
    termsConditions.siblings(".checkout-error-message").addClass("show");
  } else {
    termsConditions.siblings(".checkout-error-message").removeClass("show");
  }

  if (typeof nonce == undefined || nonce == "") {
    errors++;
    $("#dropin-container")
      .siblings(".checkout-error-message")
      .addClass("show");
    $(".braintree-card").addClass("error");
    $(".checkout-pay").trigger("click");
    clearInterval(nonceChecker);
    nonceChecker = setInterval(hasNonce, 1000);
  } else {
    $(".braintree-card").removeClass("error");
    $("#dropin-container")
      .siblings(".checkout-error-message")
      .removeClass("show");
  }

  if (errors == 0) {
    let orderData = {};
    orderData.checkoutTours = JSON.parse(localStorage.cart);
    if ($("input[name='private-or-business']:checked").val() == "private") {
      orderData.checkoutCustomer = {
        type: $("input[name='private-or-business']:checked").val(),
        firstName: firstName.val(),
        lastName: lastName.val(),
        email: email.val(),
        mobile: mobile.val(),
      };
      if (address.val() != "") {
        orderData.checkoutCustomerAdditional = {
          address: address.val(),
        };
      }
    } else {
      orderData.checkoutCustomer = {
        type: $("input[name='private-or-business']:checked").val(),
        firstName: firstNameBusiness.val(),
        lastName: lastNameBusiness.val(),
        email: emailBusiness.val(),
        mobile: mobileBusiness.val(),
      };
      if (companyAddress.val() != "") {
        orderData.checkoutCustomerAdditional = {
          address: companyAddress.val(),
          companyName: companyName.val(),
          companyAddress: companyAddress.val(),
          companyReference: companyReference.val(),
          billingEmailBusiness: billingEmailBusiness.val(),
          vat: vat.val(),
        };
      }
    }
    if (gitCardCode.val() != "") {
      orderData.checkoutGiftCard = {
        gitCard: gitCardCode.val(),
      };
    }
    if (parseInt($("#wheelchair-amount").val()) > 0) {
      orderData.checkoutAccessible = {
        amount: $("#wheelchair-amount").val(),
        type: $("#wheelchair-type").val(),
        description: $("#wheelchair-info").val(),
      };
    }

    $(".processing-overlay").addClass("show");
    $.ajax({
      url: themeVars.ajax_url,
      type: "POST",
      data: {
        action: "braintreeTransaction",
        orderData: orderData,
        currency: currency,
        city: city,
        amount: amount,
        nonce: nonce,
      },
      success: function(response) {
        console.log(response);

        if (response.success == true) {
          localStorage.removeItem("cart");
          window.location =
            themeVars["home"] + "/confirmation-page/?order=" + response.data;
          //$(".processing-overlay").removeClass("show");
        } else {
          $(".processing-overlay").removeClass("show");
          messagesBox.html("<li>" + response.data + "</li>");
        }
      },
    });
  }
  // else {
  //   let message = errorMessages.map(line => {
  //     return "<li>" + line + "</li>";
  //   });
  //   messagesBox.html(message.join(""));
  // }
});

$(document).on("click", ".tour-details", function() {
  $(this)
    .siblings(".tour-card__fist-row")
    .find(".tour-description__language")
    .toggle();
  $(this)
    .siblings(".tour-card__second-row")
    .find(".participant-details,.total,.subtotal")
    .toggle();
  $(this)
    .children("span")
    .toggleHtml("Details", "Hide")
    .toggleClass("less-info");
  console.log("ok");
});

// Remove one tour

$(".checkout-cards__edit").click(function() {
  let detailsBtns = $(".tour-details").children("span");
  let langRow = $(".tour-details")
    .siblings(".tour-card__fist-row")
    .find(".tour-description__language");
  let otherDetailsRow = $(".tour-details")
    .siblings(".tour-card__second-row")
    .find(".participant-details,.total,.subtotal");

  if ($(window).width() < 992) {
    if (!$(".remove-tour").is(":visible")) {
      $(".remove-tour").show();
      $(".remove-option").show();
      detailsBtns.each(function() {
        $(this).text() === translations.details
          ? $(this)
              .toggleHtml(translations.details, translations.hide)
              .toggleClass("less-info")
          : $(this).text(translations.hide);
      });
      langRow.show();
      otherDetailsRow.show();
      $(".tour-card__checkout").addClass("edit");
    } else {
      $(".tour-card__checkout").removeClass("edit");
      $(".remove-tour").hide();
      $(".remove-option").hide();
      detailsBtns.each(function() {
        $(this).text() === translations.hide
          ? $(this)
              .toggleHtml(translations.hide, translations.details)
              .toggleClass("less-info")
          : $(this).text(translations.details);
      });

      langRow.hide();
      otherDetailsRow.hide();
    }
  } else {
    if (!$(".remove-tour").is(":visible")) {
      $(".remove-tour").show();
      $(".remove-option").show();
    } else {
      $(".remove-tour").hide();
      $(".remove-option").hide();
    }
  }
  $(".checkout-cards__edit").toggleHtml(translations.edit, translations.done);
});
/* eslint-disable */
$(document).on("click", ".remove-tour", function(e) {
  let value = $(this)
    .parent(".tour-card")
    .attr("data-price");
  let items = [
    {
      "item-id": $(this)
        .parent(".tour-card")
        .attr("data-id"),
      "item-name": $(this)
        .parent(".tour-card")
        .attr("data-name"),
      "item-brand": $(this)
        .parent(".tour-card")
        .attr("data-brand")
    }
  ];

  removeFromCartDataLayer(value, items);

  if ($(".tour-card__checkout-wrapper").children().length == 2) {
    emptyCart();
  }
  let checkoutItemId = $(e.target)
    .parent()
    .attr("data-post-id");
  let checkoutItemDate = $(e.target)
    .parent()
    .attr("data-tour-date");

  let totalPrice = parseInt($(".total__price").text());
  let removedTourPrice = parseInt(
    $(this)
      .parent()
      .find(".subtotal__price")
      .text()
  );
  $(".total__price").html(totalPrice - removedTourPrice);

  let totalTaxes = 0;
  $(".subtotal__taxes").each(function() {
    totalTaxes = totalTaxes + parseFloat($(this).text());
  });
  $(".total__taxes").html(totalTaxes);

  cart = cart.filter(function(cartItem) {
    if (cartItem.tourDate === parseInt(checkoutItemDate)) {
      return cartItem.tourId !== checkoutItemId;
    } else {
      return cartItem.tourDate !== checkoutItemDate;
    }
  });

  localStorage.setItem("cart", JSON.stringify(cart));
  $(this)
    .parent()
    .remove();
  cartIcon.text(cart.length);
});

// Remove option

// $(document).on("click", ".remove-option", function (e) {
//   let totalPrice = parseInt($(".total__price").text());
//   let subTotalPrice = parseInt(
//     $(this)
//       .parent()
//       .parent()
//       .next(".subtotal")
//       .find(".subtotal__price")
//       .text()
//   );
//   let removedTourPrice = parseInt(
//     $(this)
//       .parent()
//       .find(".tour-price")
//       .attr("data-sigle-tour-price")
//   );
//   let removedTourTaxes =
//     $(this)
//       .parent()
//       .parent()
//       .next(".subtotal")
//       .find(".subtotal__taxes");
//   let removedTourSubtotal = $(this)
//     .parent()
//     .parent()
//     .next(".subtotal")
//     .find(".subtotal__price");
//   removedTourSubtotal.html(subTotalPrice - removedTourPrice);
//   $(".total__price").html(totalPrice - removedTourPrice);
//     removedTourTaxes.html((parseInt(removedTourSubtotal.text()) * 0.05).toFixed(2));
// $(".total__taxes").html((parseInt($(".total__price").text()) * 0.05).toFixed(2));
//   let currentOptionId = $(e.target).attr("data-option-id");

//   let checkoutItemId = $(e.target)
//     .parent()
//     .parent()
//     .parent()
//     .parent()
//     .attr("data-post-id");
//   let checkoutItemDate = $(e.target)
//     .parent()
//     .parent()
//     .parent()
//     .parent()
//     .attr("data-tour-date");

//   cart.map(function (cartItem) {
//     if (cartItem.tourId === checkoutItemId && cartItem.tourDate === checkoutItemDate) {
//       cartItem.tourVariations = cartItem.tourVariations.filter(option => {
//         // decrease options quantity if there are 2 or more same options in cart
//         if (option.tourOptionId !== currentOptionId) {
//           return option;
//         }
//       });
//     }
//   });

//   $(this).closest('.participant-details__row').remove();

//   localStorage.setItem("cart", JSON.stringify(cart));
// });
$(document).on("click", ".remove-option", function(e) {
  let totalPrice = parseInt($(".total__price").text());
  let subTotalPrice = parseInt(
    $(this)
      .parent()
      .parent()
      .next(".subtotal")
      .find(".subtotal__price")
      .text()
  );
  let removedTourPrice = parseInt(
    $(this)
      .parent()
      .find(".tour-price")
      .attr("data-sigle-tour-price")
  );
  let removedTourTaxes = $(this)
    .parent()
    .parent()
    .next(".subtotal")
    .find(".subtotal__taxes");
  let taxPercent = parseFloat(removedTourTaxes.attr("data-taxpercent"));
  let removedTourSubtotal = $(this)
    .parent()
    .parent()
    .next(".subtotal")
    .find(".subtotal__price");
  removedTourSubtotal.html(subTotalPrice - removedTourPrice);
  $(".total__price").html(totalPrice - removedTourPrice);
  removedTourTaxes.html(
    (parseInt(removedTourSubtotal.text()) * taxPercent).toFixed(2)
  );

  let totalTaxes = 0;
  $(".subtotal__taxes").each(function() {
    totalTaxes = totalTaxes + parseFloat($(this).text());
  });
  $(".total__taxes").html(totalTaxes);
  let currentOptionId = $(e.target).attr("data-option-id");
  let groupValue = $(e.target).attr("data-group-value");

  let checkoutItemId = $(e.target)
    .parent()
    .parent()
    .parent()
    .parent()
    .attr("data-post-id");
  let checkoutItemDate = $(e.target)
    .parent()
    .parent()
    .parent()
    .parent()
    .attr("data-tour-date");

  cart.map(function(cartItem) {
    if (cartItem.tourDate === checkoutItemDate) {
      cartItem.tourVariations.map(function(option) {
        // decrease options quantity if there are 2 or more same options in cart
        if (
          option.tourOptionId === currentOptionId &&
          parseInt(option.quantity) > parseInt(groupValue)
        ) {
          option.quantity = parseInt(option.quantity) - parseInt(groupValue);
          option.tourPrice =
            parseInt(option.tourPrice) - parseInt(option.tourPriceSingle);
          var currentPrice = $(e.target)
            .siblings("div")
            .find(".tour-price");
          var currentQuantity = $(e.target)
            .siblings("span")
            .find(".tour-quantity");
          var currentQuantityCalc = $(e.target)
            .siblings("span")
            .find(".tour-quantity-calc");
          currentPrice.html(currentPrice.text() - removedTourPrice);
          currentQuantity.html(currentQuantity.text() - parseInt(groupValue));
          currentQuantity.text() == 1
            ? currentQuantityCalc.html(translations.pc)
            : currentQuantityCalc.html(translations.pcs);
          return option;
        }
        // delete option if there are no same options in cart
        else if (
          option.tourOptionId === currentOptionId &&
          parseInt(option.quantity) === parseInt(groupValue)
        ) {
          // delete tour if there is only one option

          if (
            cartItem.tourVariations.length === 1 &&
            cartItem.tourId === checkoutItemId
          ) {
            cart = cart.filter(function(cartItem) {
              if (cartItem.tourDate === checkoutItemDate) {
                return cartItem.tourId !== checkoutItemId;
              } else {
                return cartItem.tourDate !== checkoutItemDate;
              }
            });
            cart.length == 0
              ? $(e.target)
                  .parent()
                  .parent()
                  .parent()
                  .parent()
                  .parent()
                  .remove() +
                emptyCart() +
                cartIcon.removeClass("counter-icon").html("")
              : $(e.target)
                  .parent()
                  .parent()
                  .parent()
                  .parent()
                  .remove() + cartIcon.html(cart.length);
          }

          // delete option if there is multiple options
          else if (
            cartItem.tourVariations.length > 1 &&
            cartItem.tourId === checkoutItemId &&
            parseInt(option.quantity) === parseInt(groupValue)
          ) {
            cartItem.tourVariations = cartItem.tourVariations.filter(function(
              option
            ) {
              return option.tourOptionId !== currentOptionId;
            });

            $(e.target)
              .parent()
              .remove();
          }
        }
      });
    }
  });

  localStorage.setItem("cart", JSON.stringify(cart));
});

/* Checkout-cart actions */
function emptyCart() {
  $(".checkout-empty").show();
  $(".checkout-fullcart").removeClass("show");
  $(".header-icons__item_cart").removeClass("filled");
  $(".total").remove();
  $(".checkout-header").hide();
  cartIcon.hide();
}



// WEBPACK FOOTER //
// ./scripts/modules/checkout.js